import { render, staticRenderFns } from "./ProductShow.vue?vue&type=template&id=eec16726&scoped=true&"
import script from "./ProductShow.vue?vue&type=script&lang=ts&"
export * from "./ProductShow.vue?vue&type=script&lang=ts&"
import style0 from "./ProductShow.vue?vue&type=style&index=0&id=eec16726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec16726",
  null
  
)

export default component.exports